import { z } from 'zod';
import { uuid, isoDateTime } from './common.js';
/** The packaging catalogue: boxes, envelopes and pallet types (data model section 9). */
export const packagingKind = z.enum(['box', 'envelope', 'pallet']);
/** Pallet sizes as YouWe print and the carriers count them. */
export const palletSize = z.enum(['full', 'half', 'quarter']);
export const packagingDto = z.object({
    id: uuid,
    code: z.string(),
    name: z.string(),
    kind: packagingKind,
    palletSize: palletSize.nullable(),
    lengthMm: z.number().int().nullable(),
    widthMm: z.number().int().nullable(),
    heightMm: z.number().int().nullable(),
    tareWeightG: z.number().int(),
    maxWeightG: z.number().int().nullable(),
    active: z.boolean(),
    sortOrder: z.number().int(),
});
export const createPackagingRequest = z.object({
    code: z.string().trim().min(1).max(20),
    name: z.string().trim().min(1).max(100),
    kind: packagingKind.default('box'),
    palletSize: palletSize.nullable().optional(),
    lengthMm: z.number().int().min(0).nullable().optional(),
    widthMm: z.number().int().min(0).nullable().optional(),
    heightMm: z.number().int().min(0).nullable().optional(),
    tareWeightG: z.number().int().min(0).default(0),
    maxWeightG: z.number().int().min(0).nullable().optional(),
    sortOrder: z.number().int().default(100),
});
export const updatePackagingRequest = createPackagingRequest.partial().extend({ active: z.boolean().optional() });
export const packageDto = z.object({
    id: uuid,
    ownerType: z.enum(['fulfilment', 'batch']),
    ownerId: uuid,
    sequence: z.number().int(),
    kind: z.enum(['parcel', 'pallet']),
    packagingId: uuid.nullable(),
    packagingName: z.string().nullable(),
    palletSize: palletSize.nullable(),
    weightG: z.number().int(),
    lengthMm: z.number().int().nullable(),
    widthMm: z.number().int().nullable(),
    heightMm: z.number().int().nullable(),
    trackingNumber: z.string().nullable(),
    createdAt: isoDateTime,
});
/** One package to register; dimensions default from the packaging, weight from the contents plus tare. */
export const packageInput = z.object({
    packagingId: uuid.nullable().optional(),
    weightG: z.number().int().min(0).nullable().optional(),
    lengthMm: z.number().int().min(0).nullable().optional(),
    widthMm: z.number().int().min(0).nullable().optional(),
    heightMm: z.number().int().min(0).nullable().optional(),
    count: z.number().int().min(1).max(200).default(1),
});
export const setPackagesRequest = z.object({ packages: z.array(packageInput).max(200) });
/** Scan-to-print: an order number, fulfilment number (`971708-1`) or batch number (`B-000001`). */
export const scanRequest = z.object({
    code: z.string().trim().min(1).max(60),
    printerId: uuid.optional(),
});
export const scanResult = z.object({
    kind: z.enum(['fulfilment', 'batch']),
    id: uuid,
    number: z.string(),
    status: z.string(),
    printed: z.array(z.string()),
    documentIds: z.array(uuid),
    message: z.string(),
});
export const scanLogDto = z.object({
    at: isoDateTime,
    code: z.string(),
    kind: z.string(),
    number: z.string(),
    printed: z.array(z.string()),
    actorName: z.string(),
});
//# sourceMappingURL=packaging.js.map